import { APP_INITIALIZER, ErrorHandler, NgModule } from "@angular/core";
import { Router } from "@angular/router";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import * as Sentry from "@sentry/angular-ivy";

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './@shared/shared.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { AuthGuard, RedirectGuard } from './auth/guard';
import { AuthGuardGuest } from './auth/guard/auth.guard-guest';
import { PusherService } from './@shared/services/pusher.service';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    TooltipModule.forRoot()
  ],
  providers: [AuthGuard, AuthGuardGuest, RedirectGuard, PusherService,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    }, {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => { },
      deps: [Sentry.TraceService],
      multi: true,
    },],
  bootstrap: [AppComponent]
})
export class AppModule { }
